export default "__VITE_ASSET__e487b9d0__"